import { IFeedback } from "../../Interfaces/Sprint/Sprint";
import {
    GetBuscarAtualizacaoServices,
    InserirVisualizacaoSprintServices,
} from "../../Services/Sprint/SprintService";
import { Controller } from "../Controller";

export async function GetBuscarAtualizacaoController(idUsuario: number) {
    return Controller(GetBuscarAtualizacaoServices(idUsuario));
}

export async function InserirVisualizacaoSprintController(feedback: IFeedback) {
    return Controller(InserirVisualizacaoSprintServices(feedback));
}
